import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { getChildFees } from "../../api/parentDashboardApi";
import { useCurrency, formatMoney } from "../../common/utils/currency";

const statusSeverity = {
  paid: "success",
  unpaid: "danger",
  pending: "warning",
  overdue: "danger",
  partial: "warning",
};

const ChildFeesTab = ({ child }) => {
  const currency = useCurrency();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!child?.id) return;
    const load = async () => {
      try {
        setLoading(true);
        const data = await getChildFees(child.id);
        if (data?.success) setItems(data.items || []);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [child?.id]);

  return (
    <DataTable value={items} loading={loading} paginator rows={10} stripedRows emptyMessage="No fee vouchers.">
      <Column field="voucher_number" header="Voucher #" />
      {/* Monthly vouchers carry a month; weekly-per-term ones carry a term. */}
      <Column
        header="Period"
        body={(row) =>
          row.term?.name
            ? `${row.term.name}${row.weeks_billed ? ` · ${row.weeks_billed} wks` : ""}`
            : row.month || "—"
        }
      />
      <Column
        field="due_date"
        header="Due"
        body={(row) => (row.due_date ? new Date(row.due_date).toLocaleDateString() : "—")}
      />
      <Column
        field="total_amount"
        header="Amount"
        body={(row) => formatMoney(row.total_amount || row.amount || 0, currency)}
      />
      <Column
        field="status"
        header="Status"
        body={(row) => <Tag value={row.status} severity={statusSeverity[row.status] || "info"} />}
      />
    </DataTable>
  );
};

export default ChildFeesTab;
